<template>
    <select-c
        v-model="modelCurrent"
        :options="options"
        :label="label"
        wrapper-class="xs:w-full"
    />
    <!-- <div class="xs:w-full">
        <div class="relative xs:w-full">
            <label class="leading-none self-center text-black mr-1" for="select-period">{{ label }}</label>
            <select class="form-control form-control-sm form-control-fixed bg-white mb-1"
                v-model="selectedIndex"
                @change="handleChange"
                id="select-period"
                :aria-label="'Select' + label"
            >
                <template v-for="(option, index) in periodOptions">
                    <option :class="{ 'bg-yellow-200': option.highlight }" :value="index">
                        {{ option.label }}
                    </option>
                </template>
            </select>
        </div>
    </div> -->
</template>

<script setup>
import { ref, watch, computed, inject, onMounted, nextTick, onBeforeMount } from 'vue';
import { useLocationHash } from '../../mixins/LocationHash';

const props = defineProps({
    options: Array,
    label: String,
    hashKey: String,
    modelValue: {
        type: [String, Number, Object],
        default: null, // You can set a default value if necessary
    },

    // Whether this component should emit the requestChanged event on initial load
    // Only used on complicated merges of the request object
    // Used on the resources/highs-lows page
    emitInitial: Boolean,
    emit: {
        type: Boolean,
        default: true
    },
});

const emit = defineEmits();
const eventBus = inject('eventBus');
const { searchHash, addToHash, hashExists } = useLocationHash();

const modelCurrent = ref(null);

// function getOptions(options) {
//     if (hashExists() && props.hashKey) {
//         const currentHash = searchHash(props.hashKey);
//         if (!currentHash) return options;
//         return options.map(mOption => ({
//             ...mOption,
//             default: mOption.label === currentHash.value
//         }));
//     } else {
//         return options;
//     }
// }

watch(modelCurrent, (newCurrent, oldCurrent) => {
    // console.log('RequestSelect: watch modelCurrent');

    if ((oldCurrent || props.emitInitial) && props.emit) {
        eventBus.emit('requestChanged', newCurrent);
    }

    if (props.hashKey) {
        // Find the label of the selected
        const selected = props.options.find(mPeriod => {
            return JSON.stringify(mPeriod.value) === JSON.stringify(modelCurrent.value);
        });
        if (selected) {
            addToHash(props.hashKey, selected.label);
        }
    }

    emit('update:modelValue', newCurrent);
});

onMounted(() => {
    if (hashExists()) {
        const periodFromHash = searchHash(props.hashKey);
        if (periodFromHash) {
            const foundPeriod = props.options.find(mPeriod => mPeriod.label === periodFromHash.value);
            if (foundPeriod) {
                modelCurrent.value = foundPeriod.value;
                nextTick(() => {
                    eventBus.emit('requestChanged', modelCurrent.value);
                });
            }
        }
    }
});
</script>
